import {useLocation} from "react-router-dom";
import {useQuery} from "./useQuery";

export const useHandleURLQueries = () => {
    const location = useLocation();
    const queryParam = useQuery();
    
    const isSamePathname = (path: string | undefined) : boolean => {
        if (location.pathname === path) return true;

        if (path) {
            let pathSplit = path.split('/');
            let locationSplit = location.pathname.split('/');

            if (!pathSplit || !locationSplit) return false;

            if (pathSplit.length)
                pathSplit = pathSplit[0] === '' ? pathSplit.slice(1) : pathSplit;

            if (locationSplit.length)
                locationSplit = locationSplit[0] === '' ? locationSplit.slice(1) : locationSplit;

            if (pathSplit.length !== locationSplit.length) return false;

            return pathSplit.every((p, idx) =>
                p.startsWith(':') ? !isNaN(parseInt(locationSplit[idx])) : (p === locationSplit[idx])
            );
        }

        return false;
    }
    
    const isLinkActive = (path: string | undefined) : boolean => {
        const keysParams = [...new Set(queryParam.keys())]
        const hasQueryParam = path?.includes('?');
        const pathnamePath = (hasQueryParam && path) ? path.split('?')[0] : path;
        
        const pathnameQueryParams = 
            (hasQueryParam && path) ? [...new Set(new URLSearchParams(path.split('?')[1]).keys())] : [];
        
        if (keysParams.length) {
            if (!path || !hasQueryParam) return false;
            if (pathnameQueryParams.length != keysParams.length) return false;
            
            return pathnameQueryParams.every(x => keysParams.includes(x))
        }
                
        return !hasQueryParam && isSamePathname(pathnamePath);
    }
    
    return { isLinkActive }
}